import React from 'react';
import {
  IPickupDropoff,
  IPickupSelection,
  ITranslationsOptionalRequired,
  IReducers,
} from '../../../interfaces';
import Select, { components } from 'react-select';
import * as styles from './index.module.scss';
import { modalMenu } from './TourDropoff.ReactSelect';
import { StaticQuery, graphql } from 'gatsby';
import { connect } from 'react-redux';

interface ISelectPickupValue {
  label: string;
  value: string;
}
interface IExternalProps {
  dropoff: IPickupDropoff | null;
  selectedDropoff: { label: string; value: string } | null;
  isValid: boolean;
  dropoffSelection: IPickupSelection | null;
  openDate?: boolean;
  triggerDate?: (date: boolean) => void;
  locale: string;

  changeDropoff(event: ISelectPickupValue, pickOrDrop: pickOrDrop): void;
  toggleSelect(newState: boolean, pickOrDrop: pickOrDrop): void;
}

interface IProps extends IExternalProps {
  localeData: {
    dropOffSubtext: ITranslationsOptionalRequired;
    pickUpSelectionPlaceholder: {
      version1: string;
      version2: string;
    };
    pudoNotAvailable: string;
    pudoDropdownSections: {
      doDontNeedHeader: string;
      doDontNeedLabel: string;
      doDropOffPlaces: string;
    };
  };
}

type pickOrDrop = 'pickup' | 'dropoff';
const TourBookingDropoff: React.FunctionComponent<IProps> = (props) => {
  const {
    dropoff,
    selectedDropoff,
    changeDropoff,
    dropoffSelection,
    localeData,
  } = props;
  const notAvailable = localeData.pudoNotAvailable;
  const options =
    !!dropoff && !!dropoff.DropoffPlaces && dropoff.DropoffPlaces.length > 0
      ? dropoff.DropoffPlaces.map((address) => {
          const { Name, Id } = address;
          return { label: Name, value: Id };
        })
      : [{ value: notAvailable, label: notAvailable }];
  if (dropoffSelection) {
    if (dropoffSelection === 'OPTIONAL') {
      const groupOptions = [
        {
          label: localeData.pudoDropdownSections.doDontNeedHeader,
          options: [
            {
              label: localeData.pudoDropdownSections.doDontNeedLabel,
              value: null,
            },
          ],
        },
        {
          label: localeData.pudoDropdownSections.doDropOffPlaces,
          options,
        },
      ];

      return (
        <div className={styles.dropoffContainer}>
          <label className={styles.label} id='dropoff'>
            {localeData.dropOffSubtext.optional}
          </label>
          <Select
            placeholder={localeData.pickUpSelectionPlaceholder.version2}
            options={groupOptions}
            onChange={(event: any) => changeDropoff(event, 'dropoff')}
            components={{ Group: components.Group }}
            styles={modalMenu}
            onMenuOpen={() => {
              props.toggleSelect(true, 'dropoff');
              if (props.triggerDate) {
                props.triggerDate(!props.openDate);
              }
            }}
            onMenuClose={() =>
              setTimeout(() => props.toggleSelect(false, 'dropoff'), 500)
            }
            aria-labelledby='dropoff'
          />
        </div>
      );
    }
    // TODO there is not diffrence in the label for dropoff in dekstop and mobile
    // like in pickup, we need to send a isMobile prop here. TODO
    if (dropoffSelection === 'PRESELECTED') {
      return (
        <div className={styles.dropoffContainer}>
          <label className={styles.label} id='dropoff'>
            {localeData.dropOffSubtext.required}
          </label>
          <Select
            placeholder={localeData.pickUpSelectionPlaceholder.version2}
            options={options}
            value={selectedDropoff ? selectedDropoff : null}
            isClearable={true}
            onChange={(event: any) => changeDropoff(event, 'dropoff')}
            components={{ SingleValue: components.SingleValue }}
            styles={modalMenu}
            onMenuOpen={() => {
              props.toggleSelect(true, 'dropoff');
              if (props.triggerDate) {
                props.triggerDate(!props.openDate);
              }
            }}
            onMenuClose={() =>
              setTimeout(() => props.toggleSelect(false, 'dropoff'), 500)
            }
            aria-labelledby='dropoff'
          />
        </div>
      );
    }
    return null;
  }
  return null;
};

const mapStateToProps = (reducers: IReducers) => {
  const { locale } = reducers.translationReducers;
  return { locale };
};

export default connect(mapStateToProps)(
  ({
    dropoff,
    selectedDropoff,
    isValid,
    dropoffSelection,
    openDate,
    triggerDate,
    changeDropoff,
    toggleSelect,
    locale,
  }: IExternalProps) => (
    <StaticQuery
      query={graphql`
        query TourBookingDropoff {
          allContentfulTranslationsBookingModal {
            edges {
              node {
                node_locale
                dropOffSubtext {
                  optional
                  required
                }
                pickUpSelectionPlaceholder {
                  version1
                  version2
                }
                pudoNotAvailable
                pudoDropdownSections {
                  doDontNeedHeader
                  doDontNeedLabel
                  doDropOffPlaces
                }
              }
            }
          }
        }
      `}
      render={(data) => {
        return (
          <TourBookingDropoff
            localeData={
              data.allContentfulTranslationsBookingModal.edges.filter(
                (node: { node: { node_locale: string } }) => {
                  return node.node.node_locale === locale;
                }
              )[0].node
            }
            dropoff={dropoff}
            selectedDropoff={selectedDropoff}
            isValid={isValid}
            dropoffSelection={dropoffSelection}
            openDate={openDate}
            triggerDate={triggerDate}
            changeDropoff={changeDropoff}
            toggleSelect={toggleSelect}
            locale={locale}
          />
        );
      }}
    />
  )
);
